export default __webpack_public_path__ + "static/media/studenthelper_slide2.f916879a.png";